import styles from './NoUsersFound.module.scss';

function NoUsersFound() {
  return (
    <div className={styles.noUsersFound}>
      <img src="/cloud.svg" alt="" />
      <h3>No users found</h3>
      <p>You haven`t created any user</p>
    </div>
  );
}

export default NoUsersFound;
